// feedbackSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomerFeedbackdata } from "../thunks/feedbackThunk";
import { submitFeedback } from "../thunks/customerThunks";

const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    status: "idle",
    loading:false,
    error: null,
    allFeedback:null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitFeedback.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(submitFeedback.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(submitFeedback.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchCustomerFeedbackdata.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerFeedbackdata.fulfilled, (state, action) => {
        state.allFeedback = action.payload;
         state.loading = false;
      })
      .addCase(fetchCustomerFeedbackdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default feedbackSlice.reducer;
